// extracted by mini-css-extract-plugin
export default {"date":"DateTime_date__+U06m","time":"DateTime_time__0V3Ju"};